import axios from 'axios'
import store from '../store/index.js'
// 根据环境变量区分接口的默认地址
// switch (process.env.NODE_ENV) {
//     case "production":
//         // 生产环境
//         axios.defults.baseURL = "https://www.conovoovo.com"
//         break;
//     default:
//         // 开发环境
//         axios.defults.baseURL = "http://127.0.0.1:8848"
// }

const request = axios.create({
    baseURL: "http://101.201.209.30", 
    // baseURL: "http://127.0.0.1:8848", 
    timeout: 10000  // 请求超时时间
})




// // 设置请求传递数据的格式 json
// axios.defults.header['Content-Type'] = 'application/json'

request.interceptors.request.use(
    config => {
        // config.headers['Content-Type'] = 'application/json;charset=utf-8';
        // config.headers['Content-Type'] = 'multipart/form-data';
        config.headers['Access-Control-Allow-Origin'] = '*';
        if (store.state.user.token) {
            config.headers["token"] = store.state.user.token
        }
       


        // 取出sessionStorage里面缓存的用户信息，是json字符串
        /*let userJson = sessionStorage.getItem("user")
        if (!userJson) {
            router.push("/login")  // 若登录用户信息为空则跳转至登录页面
        }*/
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

// 响应拦截器
request.interceptors.response.use(response => {

    return response.data
}, error => {
    let { response } = error
    if (response) {
        // 服务器返回结果
        switch (response.status) {
            // 当前请求需要用户验证（一般是未登录）
            case 401:
                break;
            // 服务器已经理解请求，但是拒绝执行它（一般是token过期）
            case 403:
                break;
            // 找不到页面
            case 404:
                break;
        }
    } else {
        // 服务器没有返回结果
        if (!window.navigator.onLine) {
            // 断网处理：可以跳转到断网页面
            return
        }
        return Promise.reject(error)
    }
})

export default request;